﻿function correctHiddenFields() {
    const partnerByEmail = document.querySelector('[data-partner-by-email]')?.innerHTML;
    const partnerByPhone = document.querySelector('[data-partner-by-phone]')?.innerHTML;
    const amOnlineByPhone = document.querySelector('[data-am-online-by-phone]')?.innerHTML;

    if (partnerByEmail === 'True') {
        document.querySelector('input[name=PartnerByEmail]').value = 'true';
    }
    if (partnerByPhone === 'True') {
        document.querySelector('input[name=PartnerByPhone]').value = 'true';
    }
    if (amOnlineByPhone === 'True') {
        document.querySelector('input[name=AMOnlineByPhone]').value = 'true';
    }
}

function checkPhoneRequirement() {
    const partnerByPhone = document.querySelector('input[name=PartnerByPhone]')?.value;
    const amOnlineByPhone = document.querySelector('input[name=AMOnlineByPhone]')?.value;
    const phoneNumber = document.querySelector("#PhoneNumber")?.value ?? '';
    const phoneValidationElement = document.querySelector("[data-phone-validation]");

    if (partnerByPhone === 'true' || amOnlineByPhone === 'false') {
        if (phoneNumber !== '') {
            phoneValidationElement.classList.add('d-none');
        } else {
            phoneValidationElement.classList.remove('d-none');
        }
    } else {
        phoneValidationElement.classList.add('d-none');
    }
}

function onRegisterClick(e) {
    checkPhoneRequirement();
    const form = document.querySelector("[data-registration-form]");
    if (!form?.checkValidity())
        return;
    e.preventDefault();
    const button = form.querySelector('button[type="submit"], input[type="submit"]');
    const partnerByPhone = document.querySelector('input[name=PartnerByPhone]').value;
    const bauerByPhone = document.querySelector('input[name=BauerByPhone]').value;
    const phoneNumber = document.querySelector("#PhoneNumber")?.value ?? '';
    if (partnerByPhone === 'true' || bauerByPhone === 'false') {
        if (phoneNumber !== '') {
            button.setAttribute('disabled', 'disabled');
            form.submit();
        } else {
            document.querySelector("[data-phone-validation]").classList.remove('d-none');
        }
    } else {
        button.setAttribute('disabled', 'disabled');
        form.submit();
    }
}

export function setupFNTheme() {
    const phoneNumberElement = document.querySelector("#PhoneNumber");
    phoneNumberElement?.addEventListener('keypress', () => {
        document.querySelector("[data-phone-validation]").classList.add('d-none');
    });
    let registerButton = document.querySelector("[data-btn-register]");
    if (registerButton) {
        registerButton.addEventListener('click', onRegisterClick);
    }
    let permutiveId = window.localStorage.getItem("permutive-id");
    let permutiveIdEl = document.querySelector("#PermutiveId")
    if (permutiveIdEl) {
        permutiveIdEl.value = permutiveId;
    }
    document.querySelector("#PartnerByPhone")?.addEventListener('change', function () {
        document.querySelector('input[name=PartnerByPhone]').value = this.checked ? 'true' : 'false';
        checkPhoneRequirement();
    });
    document.querySelector("#BauerByPhone")?.addEventListener('change', function () {
        document.querySelector('input[name=BauerByPhone]').value = this.checked ? 'true' : 'false';
        checkPhoneRequirement();
    });

    document.querySelector(".reveal")?.addEventListener('click', function () {
        let pwd = document.querySelector(".pwd");
        if (pwd.getAttribute('type') === 'password') {
            pwd.setAttribute('type', 'text');
            this.innerHTML = '<i class="bi bi-eye-fill"></i>';
        } else {
            pwd.setAttribute('type', 'password');
            this.innerHTML = '<i class="bi bi-eye-slash-fill"></i>';
        }
    });
    let industrySector = document.querySelector("#Input_IndustrySector")?.value;
    if (industrySector === "PrivateSectorOther" || industrySector === "PublicSectorOther") {
        document.querySelector('[data-other-industry-sector]').classList.remove('d-none');
    }
    document.querySelector('[data-industry-sector]')?.addEventListener('change', function () {
        if (this.value === "PrivateSectorOther" || this.value === "PublicSectorOther") {
            document.querySelector('[data-other-industry-sector]')?.classList.remove('d-none');
        } else {
            document.querySelector('[data-other-industry-sector]')?.classList.add('d-none');
        }
    });
    let jobFunction = document.querySelector('#Input_JobFunction')?.value;
    if (jobFunction === "Other") {
        document.querySelector('[data-other-job-function]')?.classList.remove('d-none');
    }
    document.querySelector('#Input_JobFunction')?.addEventListener('change', function () {
        if (this.value === "Other") {
            document.querySelector('[data-other-job-function]')?.classList.remove('d-none');
        } else {
            document.querySelector('[data-other-job-function]')?.classList.add('d-none');
        }
    });

    if ($("#decision-making-Other").is(":checked")) {
        document.querySelector('[data-other-decision-making-process]')?.classList.remove('d-none');
    }
    $(document).on('change', '#decision-making-Other', function () {
        if ($(this).is(':checked')) {
            document.querySelector('[data-other-decision-making-process]')?.classList.remove('d-none');
        }
        else {
            document.querySelector('[data-other-decision-making-process]')?.classList.add('d-none');
        }
    });
    if ($("#how-is-your-fleet-funded-Other").is(":checked")) {
        document.querySelector('[data-other-how-is-your-fleet-funded]')?.classList.remove('d-none');
    }
    $(document).on('change', '#how-is-your-fleet-funded-Other', function () {
        if ($(this).is(':checked')) {
            document.querySelector('[data-other-how-is-your-fleet-funded]')?.classList.remove('d-none');
        }
        else {
            document.querySelector('[data-other-how-is-your-fleet-funded]')?.classList.add('d-none');
        }
    });

    //let decision = document.querySelector('#decision-making-Other')?.value;
    //if (decision === "21") {
    //    document.querySelector('[data-other-decision-making-process]')?.classList.remove('d-none');
    //}
    //document.querySelector('#Input_DecisionMakingProcess')?.addEventListener('change', function () {
    //    if (this.value === "Other" || this.value === "21") {
    //        document.querySelector('[data-other-decision-making-process]')?.classList.remove('d-none');
    //    } else {
    //        document.querySelector('[data-other-decision-making-process]')?.classList.add('d-none');
    //    }
    //});
    //let funded = document.querySelector('#Input_HowIsYourFleetFunded')?.value;
    //if (funded === "8") {
    //    document.querySelector('[data-other-how-is-your-fleet-funded]')?.classList.remove('d-none');
    //}
    //document.querySelector('#Input_HowIsYourFleetFunded')?.addEventListener('change', function () {
    //    if (this.value === "Other" || this.value === "8") {
    //        document.querySelector('[data-other-how-is-your-fleet-funded]')?.classList.remove('d-none');
    //    } else {
    //        document.querySelector('[data-other-how-is-your-fleet-funded]')?.classList.add('d-none');
    //    }
    //});
    var $checkbox = $("#Input_UnSubscribeFromAll");

    $checkbox.on("change", function () {
        // Check if the checkbox is checked
        if ($checkbox.is(":checked")) {
            $(".checkbox-group").prop("checked", false);
        }
        else {
            $(".checkbox-group").prop("checked", true);
        }
    });
    $('.checkbox-group').on("change", function () {
        $checkbox.prop("checked", false);
    });
    correctHiddenFields();
}